import React, { FunctionComponent } from 'react';
import { Modal, View, Text, Pressable, ViewStyle, Platform } from 'react-native';
import { useSafeAreaInsets } from 'react-native-safe-area-context';
import MaterialCommunityIcons from 'react-native-vector-icons/MaterialCommunityIcons';
import { DialogProps } from './Dialog.types';
import styles from './Dialog.styles';

export const Dialog: FunctionComponent<DialogProps> = ({
  visible,
  onClose,
  title,
  children,
  showCloseButton = true,
  animationType = 'fade',
  transparent = true,  
  fullScreen = false,
  width,
}) => {
  const insets = useSafeAreaInsets();

  const containerWidth: ViewStyle = width ? {width} : {};
  // Sur Android, le Modal gère déjà la status bar (contenu déjà placé sous celle-ci),
  // ajouter insets.top y créerait un espace en trop. On ne l'applique donc que sur iOS.
  const fullScreenPaddingTop = fullScreen && Platform.OS === 'ios' ? insets.top : 12;
  const fullScreenPaddingBottom = fullScreen && Platform.OS === 'ios' ? insets.bottom : 12;
  // Padding horizontal supplémentaire uniquement sur Android, pour ne pas impacter iOS.
  const fullScreenPaddingHorizontal =  12;

  return (
    <Modal
      animationType={animationType}
      transparent={transparent}
      visible={visible}
      onRequestClose={onClose}
    >
      <View style={[styles.backdrop, fullScreen && styles.fullScreenBackdrop, { paddingBottom: fullScreenPaddingBottom, paddingTop: fullScreenPaddingTop, paddingHorizontal: fullScreenPaddingHorizontal }]} testID='BT_MODAL_BACKGROUND'>
        <View 
          style={[
            styles.container,
            fullScreen && styles.fullScreenContainer,
            containerWidth
          ]}
          testID='BT_MODAL_CONTENT'
        >
          {/* Header */}
          {(title || showCloseButton) && (
            <View style={styles.header}>
              {title && (
                <Text style={styles.title} numberOfLines={2}>
                  {title}
                </Text>
              )}
              {showCloseButton && onClose && (
                <Pressable
                  onPress={onClose}
                  style={styles.closeButton}
                  testID='BT_MODAL_EXIT'
                >
                  <MaterialCommunityIcons 
                    name="close" 
                    size={24} 
                    color="#666" 
                  />
                </Pressable>
              )}
            </View>
          )}

          {/* Content */}
          <View style={styles.content}>
            {children}
          </View>
        </View>
      </View>
    </Modal>
  );
};

export default Dialog;